import { apiFetch } from "./client";

export interface AIConfig {
  enabled: boolean;
}

export interface RemediationResult {
  fix: string;
  cached: boolean;
}

export interface TriageResult {
  confidence: number;
  reasoning: string;
  classification: "true_positive" | "likely_false_positive" | "needs_review";
}

export async function getAIConfig(): Promise<AIConfig> {
  return apiFetch<AIConfig>({ path: "/v1/ai/config" });
}

export async function getRemediation(findingId: string): Promise<RemediationResult> {
  return apiFetch<RemediationResult>({ path: `/v1/findings/${findingId}/remediation` });
}

export async function getTriage(findingId: string): Promise<TriageResult> {
  return apiFetch<TriageResult>({ path: `/v1/findings/${findingId}/triage` });
}
